<ng-container [ngSwitch]="field.controlType" [formGroup]="form">

    <pep-address *ngSwitchCase="'address'" [form]="form" [key]="field.key" [formattedValue]="field.formattedValue"
        [label]="field.label" [required]="field.required" [disabled]="field.disabled" [readonly]="field.readonly"
        [xAlignment]="field.xAlignment" [rowSpan]="field.rowSpan" [groupFields]="field.groupFields"
        [layoutType]="layoutType" (valueChanged)="onValueChanged($event)">
    </pep-address>

    <pep-attachment *ngSwitchCase="'attachment'" [form]="form" [key]="field.key" [src]="field.value"
        [label]="field.label" [required]="field.required" [disabled]="field.disabled" [readonly]="field.readonly"
        [xAlignment]="field.xAlignment" [rowSpan]="field.rowSpan" [isActive]="isActive" [showTitle]="showTitle"
        [layoutType]="layoutType" (elementClicked)="onClick($event)" (valueChanged)="onValueChanged($event)">
    </pep-attachment>

    <pep-checkbox *ngSwitchCase="'checkbox'" [form]="form" [key]="field.key" [value]="field.value" [label]="field.label"
        [type]="field.type" [required]="field.required" [disabled]="field.disabled" [readonly]="field.readonly"
        [xAlignment]="field.xAlignment" [rowSpan]="field.rowSpan" [additionalValue]="field.additionalValue"
        [showTitle]="showTitle" [layoutType]="layoutType" (valueChanged)="onValueChanged($event)" [isActive]="isActive">
    </pep-checkbox>

    <pep-date *ngSwitchCase="'date'" [form]="form" [key]="field.key" [value]="field.value"
        [formattedValue]="field.formattedValue" [label]="field.label" [type]="field.type" [required]="field.required"
        [disabled]="field.disabled" [readonly]="field.readonly" [textColor]="field.textColor"
        [xAlignment]="field.xAlignment" [rowSpan]="field.rowSpan" [minValue]="field.minValue"
        [maxValue]="field.maxValue" [showTitle]="showTitle" [layoutType]="layoutType"
        (valueChanged)="onValueChanged($event)" [isActive]="isActive">
    </pep-date>

    <pep-images-filmstrip *ngSwitchCase="'images'" [objectId]="objectId" [form]="form" [key]="field.key"
        [label]="field.label" [showTitle]="showTitle" [value]="field.value" [layoutType]="layoutType">
    </pep-images-filmstrip>

    <pep-image *ngSwitchCase="'image'" [objectId]="objectId" [form]="form" [key]="field.key"
        [src]="field.formattedValue" [srcLarge]="field.value" [options]="field.options" [label]="field.label"
        [type]="field.type" [required]="field.required" [disabled]="field.disabled" [readonly]="field.readonly"
        [xAlignment]="field.xAlignment" [rowSpan]="field.rowSpan" [indicatorsField]="field.indicatorsField"
        [menuField]="field.menuField" [hasCampaignField]="field.hasCampaignField" [sizeLimitMB]="field.sizeLimitMB"
        [isActive]="isActive" [layoutType]="layoutType" (elementClicked)="onClick($event)"
        (valueChanged)="onValueChanged($event)">
    </pep-image>

    <pep-internal-button *ngSwitchCase="'button'" [form]="form" [key]="field.key" [value]="field.value"
        [formattedValue]="field.formattedValue" [label]="field.label"
        [referenceObjectInternalType]="field.referenceObjectInternalType" [type]="field.type"
        [disabled]="field.disabled" [readonly]="field.readonly" [xAlignment]="field.xAlignment"
        [layoutType]="layoutType" (elementClicked)="onClick($event)" (valueChanged)="onValueChanged($event)">
    </pep-internal-button>

    <!-- [hasSubMenu]="field.hasSubMenu" -->
    <pep-menu *ngSwitchCase="'menu'" [key]="field.key" [label]="field.label" [disabled]="field.disabled"
        [xAlignment]="field.xAlignment" [options]="field.options" [layoutType]="layoutType"
        (elementClicked)="onClick($event)" (notifyMenuItemClicked)="onMenuItemClicked($event)">
    </pep-menu>

    <pep-quantity-selector *ngSwitchCase="'qs'" [form]="form" [key]="field.key" [value]="field.value"
        [formattedValue]="field.formattedValue" [label]="field.label" [type]="field.type" [required]="field.required"
        [disabled]="field.disabled" [readonly]="field.readonly" [textColor]="field.textColor"
        [xAlignment]="field.xAlignment" [rowSpan]="field.rowSpan" [lastFocusField]="field.lastFocusField"
        [alowDecimal]="field.alowDecimal" [additionalValue]="field.additionalValue"
        [notificationInfo]="field.notificationInfo" [isActive]="isActive" [layoutType]="layoutType"
        [showTitle]="showTitle" (valueChanged)="onValueChanged($event)"
        (formValidationChanged)="onFormValidationChanged($event)" (elementClicked)="onClick($event)">
    </pep-quantity-selector>

    <pep-rich-html-textarea *ngSwitchCase="'richhtmltextarea'" [form]="form" [key]="field.key" [value]="field.value"
        [label]="field.label" [required]="field.required" [disabled]="field.disabled" [readonly]="field.readonly"
        [maxFieldCharacters]="field.maxFieldCharacters" [xAlignment]="field.xAlignment" [rowSpan]="field.rowSpan"
        [showTitle]="showTitle" [layoutType]="layoutType" (valueChanged)="onValueChanged($event)" [isActive]="isActive">
    </pep-rich-html-textarea>

    <pep-select *ngSwitchCase="'select'" [form]="form" [key]="field.key" [value]="field.value"
        [formattedValue]="field.formattedValue" [label]="field.label" [type]="field.type" [required]="field.required"
        [disabled]="field.disabled" [readonly]="field.readonly" [xAlignment]="field.xAlignment"
        [rowSpan]="field.rowSpan" [options]="field.options" [showTitle]="showTitle" [layoutType]="layoutType"
        (valueChanged)="onValueChanged($event)" (formValidationChanged)="onFormValidationChanged($event)"
        [isActive]="isActive">
    </pep-select>

    <pep-separator *ngSwitchCase="'separator'" [form]="form" [key]="field.key" [label]="field.label"
        [xAlignment]="field.xAlignment" [layoutType]="layoutType">
    </pep-separator>

    <pep-signature *ngSwitchCase="'signature'" [form]="form" [key]="field.key" [src]="field.value" [label]="field.label"
        [required]="field.required" [disabled]="field.disabled" [readonly]="field.readonly"
        [xAlignment]="field.xAlignment" [rowSpan]="field.rowSpan" [isActive]="isActive" [layoutType]="layoutType"
        (valueChanged)="onValueChanged($event)">
    </pep-signature>

    <pep-textarea *ngSwitchCase="'textarea'" [form]="form" [key]="field.key" [value]="field.value" [label]="field.label"
        [required]="field.required" [disabled]="field.disabled" [readonly]="field.readonly"
        [maxFieldCharacters]="field.maxFieldCharacters" [textColor]="field.textColor" [xAlignment]="field.xAlignment"
        [rowSpan]="field.rowSpan" [lastFocusField]="field.lastFocusField" [showTitle]="showTitle"
        [layoutType]="layoutType" (valueChanged)="onValueChanged($event)" [isActive]="isActive">
    </pep-textarea>

    <pep-textbox *ngSwitchCase="'textbox'" [form]="form" [key]="field.key" [value]="field.value"
        [formattedValue]="field.formattedValue" [label]="field.label" [placeholder]="field.placeholder"
        [type]="field.type" [required]="field.required" [disabled]="field.disabled" [readonly]="field.readonly"
        [maxFieldCharacters]="field.maxFieldCharacters" [textColor]="field.textColor" [xAlignment]="field.xAlignment"
        [rowSpan]="field.rowSpan" [lastFocusField]="field.lastFocusField" [showTitle]="showTitle"
        [layoutType]="layoutType" (valueChanged)="onValueChanged($event)"
        (formValidationChanged)="onFormValidationChanged($event)" [isActive]="isActive">
    </pep-textbox>

    <pep-indicators *ngSwitchCase="'indicators'" [key]="field.key" [value]="field.value" [layoutType]="layoutType">
    </pep-indicators>
    <pep-internal-page *ngSwitchCase="'internalPage'" [hasHeightLimit]="hasHeightLimit" [field]="field"
        [layoutType]="layoutType" (childClicked)="onChildClick($event)" (childChanged)="onChildChanged($event)">
    </pep-internal-page>

    <ng-container *ngSwitchCase="'placeholder'">
    </ng-container>
</ng-container>